import React from "react";

export const AuthPaymentErrorPage = (props) => {
  return (
    <div className="auth-error-page">
      <h2 className="text-centered bold">Oops, something went wrong!</h2>
      <div className="text-centered">Something went wrong, please try again.</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/error-page/auth-payment-error-page.component.js